import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", function () {
  const newsListSwipers = document.querySelectorAll(".blk-news-list .swiper");
  newsListSwipers.forEach((swiperElement) => {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      freeMode: true,
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
          freeMode: false,
          grid: {
            rows: 1,
          },
        },
      },
    });
  });

  const teamSwipers = document.querySelectorAll(".blk-our-team .swiper");
  teamSwipers.forEach((swiperElement) => {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      breakpoints: {
        640: {
          slidesPerView: 2.2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        1200: {
          slidesPerView: 3.5,
          spaceBetween: 16,
        },
      },
      navigation: {
        nextEl: swiperElement.closest('.blk-our-team').querySelector(".swiper-button-next"),
        prevEl: swiperElement.closest('.blk-our-team').querySelector(".swiper-button-prev"),
      },
    });

    equaliseContentWrapperHeights(swiperElement);
    window.addEventListener('resize', () => equaliseContentWrapperHeights(swiperElement));
  });

  /**
   * Equalises the height of all .content-wrapper elements within a swiper
   * Finds the tallest content wrapper and applies that height to all others
   * @param {HTMLElement} swiperElement - The swiper container element
   */
  function equaliseContentWrapperHeights(swiperElement) {
    const contentWrappers = swiperElement.querySelectorAll('.content-wrapper');
    if (contentWrappers.length === 0) return;

    contentWrappers.forEach((wrapper) => {
      wrapper.style.height = 'auto';
    });

    let maxHeight = 0;
    contentWrappers.forEach((wrapper) => {
      if (wrapper.offsetHeight > maxHeight) {
        maxHeight = wrapper.offsetHeight;
      }
    });

    contentWrappers.forEach((wrapper) => {
      wrapper.style.height = maxHeight + 'px';
    });
  }

  // Infinite logo slider
  const logoSliders = document.querySelectorAll(".logo-slider-track");
  logoSliders.forEach((track) => {
    const items = track.querySelectorAll(".logo-item");
    if (items.length === 0) return;

    // Calculate total width of all items
    let totalWidth = 0;
    items.forEach((item) => {
      totalWidth += item.offsetWidth;
    });

    // Set animation duration based on width (adjust speed factor as needed)
    const duration = totalWidth / 100; // pixels per second

    // Apply animation
    track.style.animation = `logo-scroll ${duration}s linear infinite`;

    // Create keyframes dynamically
    const styleSheet = document.createElement("style");
    styleSheet.textContent = `
      @keyframes logo-scroll {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-${totalWidth / 3}px);
        }
      }
    `;
    document.head.appendChild(styleSheet);
  });

  const thumbSwiperEl = document.querySelector('.thumbSwiper');

  if (thumbSwiperEl) {
    const thumbSwiper = new Swiper(".thumbSwiper", {
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
  
      breakpoints: {
          0: {
              slidesPerView: 3,
          },
          768: {
              slidesPerView: 5,
          },
          1024: {   
              slidesPerView: 6,
          }
      }
    });
  
  
    new Swiper(".mainSwiper", {
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: thumbSwiper,
        },
        on: {
            slideChange: function () {
                updateActiveThumb(this.realIndex);
            }
        }
    });
  
    function updateActiveThumb(index) {
        document.querySelectorAll(".thumbSwiper .thumb-item")
            .forEach((el, i) => {
                el.classList.toggle("active", i === index);
            });
  
        // Auto-center selected thumbnail
        thumbSwiper.slideTo(index - 2);
    }
  
    // Initialize default highlight
    updateActiveThumb(0);
  }
  
});